import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadSearchFormService {
  _validateForm$$ = new Subject<void>();

  private _formData;
  private storageName = 'loadSearchFilter';

  public get formData() {
    return JSON.parse(localStorage.getItem(this.storageName));
  }

  public set formData(value) {
    localStorage.setItem(this.storageName, JSON.stringify(value));
  }

  deleteStorageItem() {
    localStorage.removeItem(this.storageName);
  }

  constructor() {}

  get validateForm$$() {
    return this._validateForm$$;
  }
}
